function showToolTip(elem) {
    if (elem.length) {
        elem.css({
            "visibility": "visible",
            "opacity": "1"
        }, setTimeout(function () {
            elem.css({
                "visibility": "hidden",
                "opacity": "0"
            });
        }, 5000));
    }
}


function DownbloadPDF() {

    $("button.js-ecom-download-pdf").click(function (e) {
        e.preventDefault();
        var productid = $(this).data('productid');
        var FileName = $(this).data('filename');
        var btnText = $(this).find(".js-ecom-product-button-text");
        var btnSpinner = $(this).find(".js-ecom-product-button-spinner");
        var downloadname = FileName + '_' + productid + '.pdf';
        $.ajax({
            url: '/pdfgenerator?productid=' + productid + '&eopdf=true',
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            beforeSend: function () {
                btnText.hide();
                //set spinner icon
                //btnSpinner.html("<i class='fa fa-spinner fa-spin js-ecom-product-button-spinner'></i>");
                btnSpinner.html("<img src='/files/images/svg/loading.svg' width='25px' class='js-ecom-product-button-spinner'/>");
            },
            success: function (data) {
                btnSpinner.html("<i class='js-ecom-product-button-spinner'></i>");
                btnText.show();
                download(data, downloadname, "application/pdf");
                //var a = document.createElement('a');
                //var url = window.URL.createObjectURL(data);
                //a.href = url;
                //a.download = FileName + '_' + productid + '.pdf';
                //a.click();
                //window.URL.revokeObjectURL(url);
            }
        });
    });
}
$(document).ready(function () {
    showToolTip($(".js-download-pdf-tooltip"));
    DownbloadPDF();
    // INSTAGRAM FEED SLICK SLIDER
    $('.instafeed-container').slick({
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        //prevArrow: "<a class='a-left control-c prev slick-prev'><i class='fa fa-angle-left fa-2x' style='color: #000'></i></a/>",
        //nextArrow: "<a class='a-right control-c next slick-next'><i class='fa fa-angle-right fa-2x' style='color: #000'></i></a/>",
        arrows: false,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: null,
                    nextArrow: null
                }
            }

        ]

    });


    $('.instafeed-container').on('setPosition', function () {
        var slickWidth = $(this).find('.slick-slide').width();
        $(this).find('.slick-slide').css('height', slickWidth + 'px');
    });

    $('.instafeed-container .carousel-item').each(function () {

        height = $(this).find('img').height();
        width = $(this).find('img').width();

        if (width != height) {

            $(this).find('img').css({
                'position': 'absolute',
                'left': '50%',
                'transform': 'translateX(-50%)'
            });

        } else {
            $(this).find('img').addClass('img-fluid')
        }

    });


    headerFixed();

    burgerMenu();

    search();

    productDetailJs();

    projectDetailJs();

    if (typeof slickSlider == 'function') {
        slickSlider();
    }
    novicell.cookieInfo.init();

});


// HEADER ADD CLASS FOR TRANSITION BACKGROUND COLOR
$(window).scroll(function () {
    headerFixed();
});

function productDetailJs() {
    slideToNext();

    $('.product-videos').slick({
        infinite: false,
        nextArrow: '<span class="slick-next-custom slick-arrow slick-disabled"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-right-black</title><path class="cls-1" d="M1.18,53,24,26.5,1.18,0,0,1.45l21.57,25L0,51.54Z"/></svg></span>',
        prevArrow: '<span class="slick-prev-custom slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-left-black</title><path class="cls-1" d="M22.82,0,0,26.5,22.82,53,24,51.54,2.44,26.5,24,1.45Z"/></svg></span>'
    });
    $('.product-images').slick({
        infinite: false,
        nextArrow: '<span class="slick-next-custom slick-arrow slick-disabled"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-right-black</title><path class="cls-1" d="M1.18,53,24,26.5,1.18,0,0,1.45l21.57,25L0,51.54Z"/></svg></span>',
        prevArrow: '<span class="slick-prev-custom slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-left-black</title><path class="cls-1" d="M22.82,0,0,26.5,22.82,53,24,51.54,2.44,26.5,24,1.45Z"/></svg></span>'
    });
    $('.related-products, .accessories-products').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<span class="slick-next-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-right-black</title><path class="cls-1" d="M1.18,53,24,26.5,1.18,0,0,1.45l21.57,25L0,51.54Z"/></svg></span>',
        prevArrow: '<span class="slick-prev-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-left-black</title><path class="cls-1" d="M22.82,0,0,26.5,22.82,53,24,51.54,2.44,26.5,24,1.45Z"/></svg></span>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });
}

function projectDetailJs() {


    $('.slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<span class="slick-next-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-right-black</title><path class="cls-1" d="M1.18,53,24,26.5,1.18,0,0,1.45l21.57,25L0,51.54Z"/></svg></span>',
        prevArrow: '<span class="slick-prev-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-left-black</title><path class="cls-1" d="M22.82,0,0,26.5,22.82,53,24,51.54,2.44,26.5,24,1.45Z"/></svg></span>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });

    $('.related-projects').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<span class="slick-next-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-right-black</title><path class="cls-1" d="M1.18,53,24,26.5,1.18,0,0,1.45l21.57,25L0,51.54Z"/></svg></span>',
        prevArrow: '<span class="slick-prev-custom small slick-arrow"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 53"><defs><style>.cls-1{fill:#333233;fill-rule:evenodd;}</style></defs><title>arrow-left-black</title><path class="cls-1" d="M22.82,0,0,26.5,22.82,53,24,51.54,2.44,26.5,24,1.45Z"/></svg></span>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });
}

function headerFixed() {
    var sticky = $('.header'),
        scroll = $(window).scrollTop();

    if (scroll >= 10) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
}

// OPEN VIDEO OVERLAY
$('.play').on('click', function () {
    $('.js-video-overlay').css({
        'opacity': '1',
        'left': '0'
    });

    document.body.style.overflow = 'hidden';
});
$('.close').on('click', function () {
    $('.js-video-overlay').css({
        'opacity': '0',
        'left': '-150%'
    });
    document.body.style.overflow = 'visible';

    // STOP VIDEO

});


function burgerMenu() {
    var burger = $('.js-hamburger-slide'),
        header = $('.header-mobile');

    $(burger).on('click', function () {
        $(burger).toggleClass('is-active');
        $(header).toggleClass('menu-opened');

    });
}

Handlebars.registerHelper("stripHtml", function (input) {
    var elm = document.createElement("div");
    elm.innerHTML = input;
    return elm.textContent.trim();
});

var typeaheadProductsSource = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
        url: '/typeahead/products?q=%QUERY&type=product',
        wildcard: '%QUERY'
    }
});

var typeaheadProjectSource = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
        url: '/typeahead/projects?q=%QUERY&type=project',
        wildcard: '%QUERY'
    }
});

var typeaheadVideoSource = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
        url: '/typeahead/videos?q=%QUERY&type=video',
        wildcard: '%QUERY'
    }
});

function submitParentForm(child, type) {
    if (child === null) return;
    else if (child.nodeName === "FORM") {
        var hdnType = document.createElement("input");
        hdnType.type = "hidden";
        hdnType.name = "type";
        hdnType.value = type;
        child.appendChild(hdnType);
        child.submit();
    }
    else submitParentForm(child.parentElement, type);
}


function search() {

    $('.header-icon-search, .search-overlay, .close-icon').on('click', function () {
        $('.js-search-form').toggleClass('active');
        $(input).focus();
    });

    var input = $(".search-input");
   
    $(input).typeahead(null,


        {
            name: 'search-products',
            source: typeaheadProductsSource,
            display: 'ProductName',
            templates: {
                header: "<span>" + searchproducts + "</span>",
                empty: [
                    '<div class="empty-message text-muted">',
                    searchnoproducts,
                    '</div>',
                    '<a href="/products" onclick="javascript:submitParentForm(this, \'products\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
                ].join('\n'),
                suggestion: Handlebars.compile('<a class="suggestion-link" href="{{Link}}"><div class="img-wrapper"><img src="{{Picture}}" /></div><div><strong>{{stripHtml ProductName}}</strong><br><span>{{stripHtml Shortdescription}} - Item No. {{ItemNo}}</span></div></a>'),
                footer: '<a href="/products" onclick="javascript:submitParentForm(this, \'products\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
            }
        },
        {
            name: 'search-projects',
            source: typeaheadProjectSource,
            display: 'ProductName',
            templates: {
                header: "<span>" + searchprojects + "</span>",
                empty: [
                    '<div class="empty-message text-muted">',
                    searchnoprojects,
                    '</div>',
                    '<a href="/projects" onclick="javascript:submitParentForm(this, \'projects\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
                ].join('\n'),
                suggestion: Handlebars.compile('<a class="suggestion-link" href="{{Link}}"><div class="img-wrapper"><img src="{{Picture}}" /></div><strong>{{stripHtml ProductName}}</strong></a>'),
                footer: '<a href="/projects" onclick="javascript:submitParentForm(this, \'projects\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
            }
        },
        {
            name: 'search-videos',
            source: typeaheadVideoSource,
            display: 'ProductName',
            templates: {
                header: "<span>" + searchvideos + "</span>",
                empty: [
                    '<div class="empty-message text-muted">',
                    searchnovideos,
                    '</div>',
                    '<a href="/media/videos" onclick="javascript:submitParentForm(this, \'videos\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
                ].join('\n'),
                suggestion: Handlebars.compile('<a class="suggestion-link" href="{{Link}}"><div class="img-wrapper"><img src="{{Picture}}" /></div><strong>{{stripHtml ProductName}}</strong></a>'),
                footer: '<a href="/media/videos" onclick="javascript:submitParentForm(this, \'videos\'); return false;" class="btn btn-block btn-secondary">' + viewall + '</a>'
            }
        }

    );

    //$(".close-icon").click(function () {
    //    $(this).closest('form').find("input[type=search]").val("");
    //});
}

function slideToNext() {
    var btn = $('.js-button-bounce');
    $(btn).on('click', function () {
        var nextElement = $(this).closest('.container-fluid').next();
        var headerHeight = $('.header').outerHeight();
        $("html, body").animate({
            scrollTop: $(nextElement).offset().top - headerHeight
        }, 800);
        return false;
    });
}

$('.js-active-campaignform').on('submit', function (e) {
    e.preventDefault();
    btnSpinner = $(this).find('.newsletter-busy');
    btnCheck = $(this).find('.js-validate-form');
    btnText = $(this).find('.lbl');
    errorDiv = $(this).find('.js-error');
    //console.log($(this).serialize());
    $.ajax({
        beforeSend: function () {
            btnText.hide();
            btnSpinner.show();
        },
        url: $(this).attr('action'),
        type: 'POST',
        data: $(this).serialize(),
        success: function (data) {

            if (data == true) {

                btnSpinner.hide();
                btnCheck.append("<i class='fa fa-check'></i>");
                setTimeout(function () {
                    btnCheck.find('.fa.fa-check').remove();
                    $('.lbl').show();
                }, 1000);

            } else if (data == "false2") {
                errorDiv.html("Something went wrong");
                errorDiv.show();
                btnSpinner.hide();
                btnCheck.append("<i class='fa fa-exclamation'></i>");
                setTimeout(function () {
                    btnCheck.find('.fa.fa-exclamation').remove();
                    btnText.show();
                }, 1000);
                setTimeout(function () {
                    errorDiv.hide();
                }, 2000);

            } else {
                errorDiv.show();
                btnSpinner.hide();
                btnCheck.append("<i class='fa fa-exclamation'></i>");
                setTimeout(function () {
                    btnCheck.find('.fa.fa-exclamation').remove();
                    btnText.show();
                }, 1000);
                setTimeout(function () {
                    errorDiv.hide();
                }, 2000);

            }
        },
        error: function (jqXhr, textStatus, errorThrown) {
            console.log(jqXhr);
        }
    });
});

$(document).on('click', ".js-slideto-anchor", function (event) {
    event.preventDefault();
    var href = $.attr(this, 'href');
    var res = href.replace(/\//i, "");
    var isactive = $.attr(this, 'data-target');
    var activeTab = $.attr(this, 'rel');

    var targetOffset = $(res).offset().top - 200;

    $('.tabs li').removeClass('active');
    $("#" + isactive).addClass('active');

    $(".tab-content").hide();

    $("#" + activeTab).show();

    $('html, body').animate({
        scrollTop: targetOffset
    }, 500, function () {

    });
    return false;
});


// CONTACT COUNTRY FILTER
$('.js-ajax-container').on('change', '.country-selector', function () {
    var country = $(this).val();
    //var url = window.location.href + "?country=" + country;
    var url = window.location.href.split('?')[0] + "?country=" + country;

    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?country=' + country;
        window.history.pushState({ path: newurl }, '', newurl);
    }
    updateData(url, false);

});

$('.js-ajax-container').on('click', '.reset_filter', function () {
    console.log("reset!!");
    var url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: newurl }, '', newurl);
    }
    updateData(url, true);
});

// PROJECT FILTER

var filters = {};

$('.js-ajax-container').on('change', '.js-project-filter', function () {
    var value = $(this).val();
    var name = $(this).attr('id');

    filters[name] = value;

    var params = $.param(filters);

    var url = window.location.href.split('?')[0] + "?" + params;

    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
        window.history.pushState({ path: newurl }, '', newurl);
    }
    updateData(url, false);

});

function updateData(url, hide) {
    var container = $('.js-ajax-container');
    $.ajax({
        url: url,
        success: function (resp) {
            data = resp;
            $('.js-filter-spinner').show();
            $("body").trigger("eCom:PageChanged");
            setTimeout(
                function () {
                    $(container).html($(data).find('.js-ajax-container-switch'));
                    $('.js-filter-spinner').hide();
                    if (hide) {
                        $('.reset_filter').hide();
                    } else {
                        $('.reset_filter').show();
                    }
                    initInfiniteScroll();
                }, 500);

        },
        error: function () { }
    });
}



// PARALLAX SCROLLING
$(document).on('scroll', function () {
    if ($(".parallax").length) {
        if ($(this).scrollTop() >= $('.parallax').offset().top - 400) {
            $('.parallax').addClass("triggered");
        } else {

        }
    }
});


// STICKY LEFT MENU
function setEcomMenu() {

    var headerHeight = $(".header").height() * 2;

    // Do nothing when element is not present
    if ($(".js-ecom-content").length == 0)
        return;

    if ($(".js-ecom-content").offset().top < $(document).scrollTop() + headerHeight) {
        if ($('.js-productlist-filters-container').hasClass("is-sticky")) return;
        var diff = ($(document).scrollTop() + headerHeight) - $(".js-ecom-content").offset().top;

        if (diff > headerHeight) {
            diff = headerHeight;
            $('.js-productlist-filters-container').addClass("is-sticky");
        }
        $('.js-productlist-filters-container').css('padding-top', diff + 'px');

    }

    else {
        $('.js-productlist-filters-container').css('padding-top', '0px').removeClass("is-sticky");
    }
}

function preSetEcomMenu() {


    if ($('.js-productlist-filters-container').length) {
        //console.log($('.js-container').outerHeight())
        //console.log($('.js-ecom-nav').outerHeight())
        var ecomHeight = $('.js-ecom-content').outerHeight();
        var navHeight = $(".js-productlist-filters-container").outerHeight();

        if (navHeight > ecomHeight) {
            $('.js-sticky-sidebar').height(navHeight);
        }
        else {
            $('.js-sticky-sidebar').height(ecomHeight);
        }

        // Sticky the menu
        //console.log($('.js-menu-sticky').height())
        $('.js-productlist-filters-container').stickyfloat();

        $(document).scroll(function () {
            setEcomMenu();
        });

        setEcomMenu();
    }

    // Sticky the menu
    //console.log($('.js-menu-sticky').height())
    $('.js-productlist-filters-container').stickyfloat();
}

$(function () {
    if ($(window).width() > 960) {
        preSetEcomMenu();
    }

    $('.js-sticky-sidebar').height("auto");
});

$(window).resize(function () {
    if ($(window).width() > 960) {
        $('.js-sticky-sidebar').show();
        preSetEcomMenu();
    } else {
        $('.js-sticky-sidebar').css('height', 'auto');
        $('.js-productlist-filters-container').css({
            'padding': '20px',
            'top': '50px'
        });
    }
});



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//PRODUCTLIST INFINITE SCROLL & QUICKVIEW

var loadNextPageTriggerElement = null;
var nextPageUrl = null;
var pageContainerSelector = "#main-content";
var listView = {};
var productView = {};
var listFooterText = "";

function changeView(fromView, toView) {
    fromView.scrollTop = $(document).scrollTop(); //save current scroll state
    fromView.content = $(pageContainerSelector + " > *").detach(); //detach current state content from page

    document.title = toView.title; //update page title
    $(pageContainerSelector).append(toView.content); //append new state content
    //window.scrollTo(0, 0);

    $(document).scrollTop(toView.scrollTop); //scroll into position
}

var productJQXHR = null;
function openProductHandler() {
    if (detectingClientState) setDetectClientState(false);
    if (productJQXHR != null) productJQXHR.abort(); //cancel any unresolved quick-view requests before making a new one -> this will trigger the "always" AND the "fail" callback on the productJQXHR promise
    if (nextPageJQXHR != null) nextPageJQXHR.abort(); //cancel any unresolved "next page" requests before making the product request
    $listitem = $(this).closest(".js-productlist-item");
    $listitem.addClass("loading");
    var productUrl = this.href;
    productJQXHR = $.get(productUrl).always(function () { //get product page using ajax
        $listitem.removeClass("loading");
    }).done(function (data, textStatus, jqXHR) {
        if (textStatus == "success") {
            $responseHtml = $(data);
            productView = { //reset productView Object
                url: productUrl,
                title: $responseHtml.filter('title').text(),
                content: $(pageContainerSelector + " > *", $responseHtml),
                scrollTop: 0
            }

            history.pushState("prodview", productView.title, productView.url); //create new history state for product
            changeView(listView, productView); //show product

            // GET PRODUCT JS
            productDetailJs();
            projectDetailJs();
            DownbloadPDF();
            showToolTip($(".js-download-pdf-tooltip"));

            // HIDE HEADER
            $('.ecom-header-container').hide();

            // GET PRODUCT FOOTER DATA
            listFooterText = $('.ecom-footer-container').html();
            var footer = $(".ecom-footer-container", $responseHtml);
            $(".ecom-footer-container").replaceWith(footer);

            // INITIALIZE BOOTSTRAP TABS
            // tabs
            $(".js-tab-content").hide();
            $(".js-tab-content:first").show();

            // if in tab mode 
            $("ul.tabs li").click(function () {

                $(".tab-content").hide();
                var activeTab = $(this).attr("rel");
                $("#" + activeTab).show();

                $("ul.tabs li").removeClass("active");
                $(this).addClass("active");

            });

            // GET RESPONSIVE TABS
            tabs();

            // BIND AJAX BUTTON
            addBasketEventListener($(".js-ecom-product-form"));

        } else {
            jqXHR.reject(); //reject the promise and trigger fail callback
        }
    }).fail(function () {
        productJQXHR = null;
        //handle error here
    });
    return false; //prevent the default action of the product link
}


var nextPageJQXHR = null;
function loadNextPage(url) {

    if ((nextPageJQXHR != null && nextPageJQXHR.readyState != 4) || (productJQXHR != null && productJQXHR.readyState != 4)) { //readyState 4 == The XHR request is complete
        return false; //return if a any request is already in progress
    }
    $(".js-pagination-container").addClass("loading"); //show loading icon
    nextPageJQXHR = $.get(url).always(function () { //get next page using ajax
        $(".js-pagination-container").removeClass("loading");
    }).done(function (data, textStatus, jqXHR) {
        if (textStatus == "success") {
            $responseHtml = $(data);
            attachListLinkHandlers($responseHtml); //attach eventhandlers to incoming elements
            var productCategory = $(".category-name", $responseHtml);
            var cat = $(".product-cat", $responseHtml);
            var productCat = productCategory + ", ";
            var categoryArr = [];
            var subCategoryArr = [];

            // CREATE ARRAY OF UNIQUE CATEGORY NAMES FOR COMPARISON
            $('.category-name').each(function () {
                var found = $.inArray($(this).text(), categoryArr);
                if (found >= 0) {
                    // Element was found, do nothing.
                } else {
                    // Element was not found, add it.
                    categoryArr.push($(this).text());
                }
            });
            $('.sub').each(function () {
                var subcat = $(this).attr('data-container') + "(" + $(this).text() + ")";
                var found = $.inArray(subcat, subCategoryArr);
                if (found >= 0) {
                    // Element was found, do nothing.
                } else {
                    // Element was not found, add it.       
                    subCategoryArr.push(subcat);
                }
            });

            // ONLY APPEND CATEGORY IF NOT ALREADY APPENDED
            $(productCategory).each(function (index, element) {
                var inArr = $.inArray($(this).text(), categoryArr);
                if (inArr >= 0) {

                    $(this).parent('.product-cat').remove();
                }
            });

            $(cat).each(function (index, element) {
                var subcat = $(this).children('.sub').attr('data-container') + "(" + $(this).children('.sub').text() + ")";
                var inSubArr = $.inArray(subcat, subCategoryArr);
                if (inSubArr >= 0) {
                    $(this).remove();
                }
            });



            // IF SUB CATEGORY IS EMPTY == REMOVE()
            $(cat).each(function () {
                if ($(this).children('.sub').is(':empty')) {
                    $(this).remove();
                }
            });

            var $listitems = $(".product-cat, .js-productlist-item, .js-card-item", $responseHtml); //find list items in response
            $($listitems).each(function (i) {
                $(this).addClass('animate');
            });


            var pageLink = $(".js-productlist-infinite").siblings().children('.js-next-page-link');
            var containerLink = $(".js-productlist-infinite").siblings(".js-pagination-container");

            if ($("#content1").is(':visible')) {
                $listitems.appendTo(".js-productlist-infinite"); //append new list items into DOM
            }
            else if ($("#content2").is(':visible')) {
                $listitems.appendTo(".js-infinite-search-entertainment"); //append new list items into DOM
                pageLink = $(".js-infinite-search-entertainment").siblings().children('.js-next-page-link');
                containerLink = $(".js-infinite-search-entertainment").siblings(".js-pagination-container");
            }
            else if ($("#content3").is(':visible')) {
                $listitems.appendTo(".js-infinite-search-architectural"); //append new list items into DOM
                pageLink = $(".js-infinite-search-architectural").siblings().children('.js-next-page-link');
                containerLink = $(".js-infinite-search-architectural").siblings(".js-pagination-container");
            }
            else if ($(".js-infinite-cards").is(':visible')) {
                $listitems.appendTo(".js-infinite-cards"); //append new list items into DOM
                pageLink = $(".js-infinite-cards").siblings().children('.js-next-page-link');
                containerLink = $(".js-infinite-cards").siblings(".js-pagination-container");
            }
            else {
                $listitems.appendTo(".js-productlist-infinite"); //append new list items into DOM
            }

            loadNextPageTriggerElement = null;
            var $pagination = $(".js-pagination-container", $responseHtml); //get pagination from response
            if ($(pageLink, $pagination).length) {
                loadNextPageTriggerElement = $listitems[0]; //get first appended list item
                $(containerLink).replaceWith($pagination); //update pagination DOM
                if (!detectingClientState) setDetectClientState(false); //activate scroll/resize detection
            } else {
                $(containerLink).remove(); //remove pagination from DOM when no more pages to load
            }

            //REFRESH ECOM HEIGHT
            if ($(window).width() > 960) {
                preSetEcomMenu();
            }

            // BIND AJAX BUTTON
            addBasketEventListener($(".js-ecom-product-form"));

        } else {
            jqXHR.reject(); //reject the promise and trigger fail callback
        }
    }).fail(function () {
        nextPageJQXHR = null;
        //handle error here
    });
}

function attachListLinkHandlers(container) { //attach handlers to product and next page links (use this function after updating list with ajax)
    $('.js-product-link', container).on('click', openProductHandler); //handle click on product links
    addBasketEventListener(".js-basket-add", container); //handle addToBasket
    $('.js-next-page-link', container).on('click', loadNextPageEventHandler); //handle click on next page link
}

window.onpopstate = function (event) { //browser back/forward action

    if (event.state != null) { //some browsers will fire popstateevent onload - we dont want to handle that event

        if (event.state == "prodview" && productView != null && typeof productView.content != "undefined" && productView.content.length > 0) { //forward from list to product view
            if (detectingClientState) setDetectClientState(false); //disable scroll/resize detection
            //if (facetJQXHR != null) facetJQXHR.abort(); //abort any running facet requests
            if (nextPageJQXHR != null) nextPageJQXHR.abort(); //abort any running page requests
            changeView(listView, productView); //show product view
            $('.ecom-header-container').hide();
        } else if (event.state == "listview" && listView != null && typeof listView.content != "undefined" && listView.content.length > 0) { //backward from product to list view
            // SHOW HEADER
            $('.ecom-header-container').show();
            // GET PRODUCT FOOTER DATA
            console.log(listView.content);
            $(".ecom-footer-container").html(listFooterText);
            changeView(productView, listView); //show list 
            $('.ecom-header-container').show();
            if (!detectingClientState && loadNextPageTriggerElement != null) setDetectClientState(true); //enable scroll/resize detection if a triggerelement exists
        } else {
            location.reload();
        }
    }

}




function loadNextPageEventHandler(event) {

    if (productJQXHR != null) productJQXHR.abort(); //cancel product request if "next page" is clicked

    loadNextPage(this.href);

    return false; //prevent the default action of the next page link
}

var loadNextPageCheck = debounce(function () { //run function through a debouncer
    if (loadNextPageTriggerElement != null && loadNextPageTriggerElement.getBoundingClientRect().top < $(window).height()) { //check if the trigger element is OR has been visible

        //loadNextPage($(".js-next-page-link").attr("href"));
    }
}, 100);


function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

var detectingClientState = false;
function setDetectClientState(active) {
    detectingClientState = active;
    if (active) {
        $(document).on("scroll", loadNextPageCheck); //normally we would use "window" as our selector for the scroll event !!!
        $("window").on("resize", loadNextPageCheck);
    } else {
        $(document).off("scroll", loadNextPageCheck);
        $("window").off("resize", loadNextPageCheck);
    }
}

function initInfiniteScroll() {
    attachListLinkHandlers(); // attach handlers to links
    $('.js-product-link').on('click', openProductHandler); //handle click on product links
    listView.title = document.title; //save list page title
    history.replaceState("listview", listView.title, location.href); //manipulate current history state
    $('.js-next-page-link').on('click', loadNextPageEventHandler); //handle click on next page link
    // LOADING MORE PRODUCTS ON SCROLL
    $(window).scroll(function () {

        if ($('.js-productlist-infinite').is(":visible")) {

            if (($(window).height() + $(window).scrollTop()) > ($('.js-productlist-infinite').offset().top + $('.js-productlist-infinite').height() + 200)) {

                // IF PRODUCTS
                if ($(".your-choises").is(':visible') && $(".js-productlist-infinite").siblings().children('.js-next-page-link').length
                    || $("#mobile-filter-toggle").is(':visible') && $(".js-productlist-infinite").siblings().children('.js-next-page-link').length) {
                    $('.js-infinite-spinner').show();
                    $(".js-productlist-infinite").siblings().children('.js-next-page-link').click();
                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }

                // IF PROJECTS
                else if ($(".projects-form").is(':visible') && $(".js-productlist-infinite").siblings().children('.js-next-page-link').length) {
                    $('.js-infinite-spinner').show();

                    $(".js-productlist-infinite").siblings().children('.js-next-page-link').click();

                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }

                // IF SEARCH PROJECTS
                else if ($("#content1").is(':visible') && $(".js-productlist-infinite").siblings().children('.js-next-page-link').length) {
                    $('.js-infinite-spinner').show();
                    $(".js-productlist-infinite").siblings().children('.js-next-page-link').click();
                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }
            }
        }

        //IF SEARCH PRODUCTS ENTERTAINMENT
        else if ($('.js-infinite-search-entertainment').is(":visible")) {

            if (($(window).height() + $(window).scrollTop()) > ($('.js-infinite-search-entertainment').offset().top + $('.js-infinite-search-entertainment').height() + 200)) {
                if ($("#content2").is(':visible') && $(".js-infinite-search-entertainment").siblings().children('.js-next-page-link').length) {
                    $('.js-infinite-spinner').show();
                    $(".js-infinite-search-entertainment").siblings().children('.js-next-page-link').click();

                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }
            }
        }

        //IF SEARCH PRODUCTS ARCHITECTURAL
        else if ($('.js-infinite-search-architectural').is(":visible")) {

            if (($(window).height() + $(window).scrollTop()) > ($('.js-infinite-search-architectural').offset().top + $('.js-infinite-search-architectural').height() + 200)) {

                if ($("#content3").is(':visible') && $(".js-infinite-search-architectural").siblings().children('.js-next-page-link').length) {
                    $('.js-infinite-spinner').show();
                    $(".js-infinite-search-architectural").siblings().children('.js-next-page-link').click();

                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }
            }
        }

        // CONTACT 
        else if ($('.js-ajax-container').is(":visible")) {
            if (($(window).height() + $(window).scrollTop()) > ($('.js-ajax-container').offset().top + $('.js-ajax-container').height() + 200)) {

                if ($(".country-selector").is(':visible') && $(".js-infinite-cards").siblings().children('.js-next-page-link').length) {

                    $('.js-infinite-spinner').show();
                    $(".js-infinite-cards").siblings().children('.js-next-page-link').click();
                    setTimeout(
                        function () {
                            $('.js-infinite-spinner').hide();
                        }, 500);
                }
            }
        }



    });
}
function functionFoo(e) {
    alert(e.data.msg);
}

$(document).ready(function () {
    if ($(".js-productlist-infinite").length) {
        initInfiniteScroll();
    }
    else if ($(".js-infinite-cards").length) {
        initInfiniteScroll();
    }

});

// LOAD AJAX ADD TO CARD ON NEWLY ADDED PRODUCTS
$("body").on("eCom:PageChanged", function () {

    addBasketEventListener($(".js-ecom-product-form"));

    if ($("#content1").is(':visible')) {
        if ($(".js-productlist-infinite").length) {
            initInfiniteScroll();
        }
    }
    else if ($("#content2").is(':visible')) {
        if ($(".js-infinite-search-entertainment").length) {
            initInfiniteScroll();
        }
    }
    else if ($("#content3").is(':visible')) {
        if ($(".js-infinite-search-architectural").length) {
            initInfiniteScroll();
        }
    }
    else if ($(".js-ajax-container").is(':visible')) {
        initInfiniteScroll();
    }

    else {
        initInfiniteScroll();

    }

});


$(document).on('click', '.js-mobile-filter', function () {
    $('.mobile-filter-container').fadeIn()
});


///////////////////////////////// SEARCH INFINITE SCROLL ////////////////////////////////////////////////////


// SEARCH ENTERTAINMENT
$(window).ready(function () {

    if ($('.js-tab-radio').length) {
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get("q") != null) {
            var urlEnt = "/products/entertainment?q=" + searchParams.get("q");
        } else {
            var urlEnt = "/products/entertainment";
        }

        var containerEnt = $('.js-infinite-search-entertainment');

        $.ajax({
            url: urlEnt,
            success: function (resp) {
                data = resp;
                $('.js-spinner').show();
                setTimeout(
                    function () {
                        var elements = $(data).find('.productlist-item');
                        if ($(data).find('.productlist-item.grid').length == 12) {
                            $('.ent-amount').html("(12+)");
                        } else {
                            $('.ent-amount').html("(" + $(data).find('.productlist-item.grid').length + ")");
                        }
                        $(containerEnt).html(elements);
                        $(containerEnt).parent().append($(data).find('.infinite-spinner-container'));
                        $(containerEnt).parent().append($(data).find('.js-pagination-container'));
                        $('.js-spinner').hide();
                        loadArchitectural();
                    }, 500);
            },
            error: function () { }
        });
    }
});

function setSearchPageType(type) {
    document.querySelector("input[type='hidden'][name='type']").value = type;
}

// SEARCH ARCHITECTURAL
function loadArchitectural() {
    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("q") != null) {
        var urlArc = "/products/architectural?q=" + searchParams.get("q");
    } else {
        var urlArc = "/products/architectural";
    }

    var containerArc = $('.js-infinite-search-architectural');

    $.ajax({
        url: urlArc,
        success: function (resp) {
            data = resp;
            $('.js-spinner').show();
            setTimeout(
                function () {
                    var elements = $(data).find('.productlist-item');
                    if ($(data).find('.productlist-item.grid').length == 12) {
                        $('.arc-amount').html("(12+)");
                    } else {
                        $('.arc-amount').html("(" + $(data).find('.productlist-item.grid').length + ")");
                    }

                    $(containerArc).html(elements);
                    $(containerArc).parent().append($(data).find('.infinite-spinner-container'));
                    $(containerArc).parent().append($(data).find('.js-pagination-container'));

                    $('.js-spinner').hide();
                    initInfiniteScroll();
                }, 500);
        },
        error: function () { }
    });
}


// ON CONTACT FORM SUBMIT
$('.js-contact-form').submit(function (e) {
    e.preventDefault();
    var $form = $(this);
    if (!$form.valid()) return false;

    $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: $form.serialize(),
        success: function (response) {
            $(".js-contact-form").prepend('<span class="text-xs-center js-thank-you">Thank you for your message. We will get in contact as soon as possible</span>');
            setTimeout(function () {
                $('.js-thank-you').remove();
            }, 5000);
            $form[0].reset();
        }
    });
});



// PARALLAX DIFFERENT SCROLL SPEED
$.fn.moveIt = function () {
    var $window = $(window);
    var instances = [];
    var fromTop = 0;

    $(this).each(function () {
        instances.push(new moveItItem($(this)));
    });

    window.addEventListener('scroll', function () {
        var scrollTop = $window.scrollTop();

        // CHECK IF THERE IS ANY PARALLAXED ELEMENT
        if ($('.js-parallax-container').length) {

            // CALL FUNCTION WHEN SCROLLED TO ELEMENT
            if ($(this).scrollTop() >= $('.js-parallax-container').offset().top - $(window).height()) {
                fromTop = scrollTop;

                instances.forEach(function (inst) {
                    inst.update(scrollTop);
                });
            }
        }


    }, { passive: true });
}

var moveItItem = function (el) {
    this.el = $(el);
    this.speed = parseInt(this.el.attr('data-scroll-speed'));
};

moveItItem.prototype.update = function (scrollTop) {
    var scroll = "";

    // HANDLE TOP ELEMENTS
    if (this.el.closest('.js-parallax-container.top').length) {
        scroll = scrollTop;
        if (-(scroll / this.speed) < -(this.el.attr('data-max-height'))) {

        }
        else {
            this.el.css('transform', 'translateY(' + (scroll / this.speed) + 'px)');
        }
    }
    // HANDLE NORMAL ELEMENTS
    else {
        var height = this.el.parent().offset().top - $(window).height();
        var scroll = -height + scrollTop;


        if (-(scroll / this.speed) < -(this.el.attr('data-max-height'))) {

        }
        else {
            this.el.css('transform', 'translateY(' + (scroll / this.speed - this.el.attr('data-max-height')) + 'px)');

        }
    }


};

//Initialization
$(function () {
    $('[data-scroll-speed]').moveIt();
});


// NEW CUSTOM EFFECTS ON LOAD
$(function () {

    window.addEventListener('load', function () {
        var video = $('#bgvid');
        var bgImage = $('.js-has-bg');

        // CHECK IF VIDEO EXIST
        if ($(video).length) {
            // CHECK IF VIDEO HAS LOADED
            function checkLoad() {
                if (video[0].readyState === 4) {
                    setTimeout(function () {
                        $('.js-fade-effect').addClass('active');
                    }, 500);
                    setTimeout(function () {
                        $('.js-slidedown-effect').addClass('active');
                    }, 1500);
                } else {
                    setTimeout(checkLoad, 100);
                }
            }

            checkLoad();
        }
        // CHECK IF BG IMAGE EXIST
        else if ($(bgImage).length && $(video).length < 1) {

            $.fn.bgLoaded = function (custom) {
                var self = this;
                // Default plugin settings
                var defaults = {
                    afterLoaded: function () {
                        this.addClass('bg-loaded');
                    }
                };

                // Merge default and user settings
                var settings = $.extend({}, defaults, custom);

                // Loop through element
                self.each(function () {
                    var $this = $(this),
                        bgImgs = $this.css('background-image').split(', ');
                    $this.data('loaded-count', 0);

                    $.each(bgImgs, function (key, value) {
                        var img = value.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                        $('<img/>').attr('src', img).on('load', function () {
                            $(this).remove(); // prevent memory leaks
                            $this.data('loaded-count', $this.data('loaded-count') + 1);
                            if ($this.data('loaded-count') >= bgImgs.length) {
                                settings.afterLoaded.call($this);
                            }
                        });
                    });

                });
            };

            // CHECK IF BG IMAGE HAS LOADED
            $('.js-has-bg').bgLoaded({
                afterLoaded: function () {
                    $('.js-fade-effect').addClass('active');
                    setTimeout(function () {
                        $('.js-slidedown-effect').addClass('active');
                    }, 1000);
                }
            });
        }




    }, false);

});

$('.js-create-user-form').closest('form').submit(function () {

    $('.js-create-user-form').attr("disabled", true);
    var email = $('.js-email').val();
    var list = "list_id=2";
    if ($(".js-allow-email").is(":checked")) {
        $.ajax({
            url: '/systemactivecampaign',
            type: 'POST',
            data: "email_address=" + email + "&list_id=2",
            success: function (data) {
            }
        });
    }
});

function viewDMXCharts(event) {
    event.preventDefault();

    $('div.js-tab-content').hide();
    $('#download').show()
    $('div[data-name="DMXCharts"]').collapse("show");
    $("ul.tabs li[rel=download]").tab("show");

    var target = $.attr(event.target, 'href');
    var targetOffset = $(target).offset().top - 200;

    $('html, body').animate({
        scrollTop: targetOffset
    }, 500, function () { });
}

function viewDMXCharts(event) {
    event.preventDefault();

    $('div.js-tab-content').hide();
    $('#download').show()
    $('div[data-name="DMXCharts"]').collapse("show");
    $("ul.tabs li[rel=download]").tab("show")

    var target = $.attr(event.target, 'href');
    var targetOffset = $(target).offset().top - 200;

    $('html, body').animate({
        scrollTop: targetOffset
    }, 500, function () { });
}

//download.js v4.2, by dandavis; 2008-2016. [CCBY2] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.download = factory();
    }
}(this, function () {

    return function download(data, strFileName, strMimeType) {

        var self = window, // this script is only for browsers anyway...
            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
            mimeType = strMimeType || defaultMime,
            payload = data,
            url = !strFileName && !strMimeType && payload,
            anchor = document.createElement("a"),
            toString = function (a) { return String(a); },
            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
            fileName = strFileName || "download",
            blob,
            reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
            payload = [payload, mimeType];
            mimeType = payload[0];
            payload = payload[1];
        }


        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
            fileName = url.split("/").pop().split("?")[0];
            anchor.href = url; // assign href prop to temp anchor
            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                var ajax = new XMLHttpRequest();
                ajax.open("GET", url, true);
                ajax.responseType = 'blob';
                ajax.onload = function (e) {
                    download(e.target.response, fileName, defaultMime);
                };
                setTimeout(function () { ajax.send(); }, 0); // allows setting custom ajax headers using the return:
                return ajax;
            } // end if valid url?
        } // end if url?


        //go ahead and download dataURLs right away
        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                payload = dataUrlToBlob(payload);
                mimeType = payload.type || defaultMime;
            } else {
                return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                    saver(payload); // everyone else can save dataURLs un-processed
            }

        }//end if dataURL passed?

        blob = payload instanceof myBlob ?
            payload :
            new myBlob([payload], { type: mimeType });


        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/),
                type = parts[1],
                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                binData = decoder(parts.pop()),
                mx = binData.length,
                i = 0,
                uiArr = new Uint8Array(mx);

            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

            return new myBlob([uiArr], { type: type });
        }

        function saver(url, winMode) {

            if ('download' in anchor) { //html5 A[download]
                anchor.href = url;
                anchor.setAttribute("download", fileName);
                anchor.className = "download-js-link";
                anchor.innerHTML = "downloading...";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                setTimeout(function () {
                    anchor.click();
                    document.body.removeChild(anchor);
                    if (winMode === true) { setTimeout(function () { self.URL.revokeObjectURL(anchor.href); }, 250); }
                }, 66);
                return true;
            }

            // handle non-a[download] safari as best we can:
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                if (!window.open(url)) { // popup blocked, offer direct download:
                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) { location.href = url; }
                }
                return true;
            }

            //do iframe dataURL download (old ch+FF):
            var f = document.createElement("iframe");
            document.body.appendChild(f);

            if (!winMode) { // force a mime that will download:
                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            }
            f.src = url;
            setTimeout(function () { document.body.removeChild(f); }, 333);

        }//end saver




        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
            return navigator.msSaveBlob(blob, fileName);
        }

        if (self.URL) { // simple fast and modern way using Blob and URL:
            saver(self.URL.createObjectURL(blob), true);
        } else {
            // handle non-Blob()+non-URL browsers:
            if (typeof blob === "string" || blob.constructor === toString) {
                try {
                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                } catch (y) {
                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                }
            }

            // Blob but not URL support:
            reader = new FileReader();
            reader.onload = function (e) {
                saver(this.result);
            };
            reader.readAsDataURL(blob);
        }
        return true;
    }; /* end download() */
}));